import './Frontend.css';
import VerticalStepper from '../UI/VerticalStepper';
import { useEffect, useState } from 'react';
import HomeNavbar from '../UI/HomeNavbar';
import { useUserAuth } from '../../context/UserAuthContext';
import LoadingModal from '../UI/LoadingModal';
import ErrorModal from '../UI/ErrorModal';

const Frontend = ({ saveProgressData, getProgressData }) => {
    const HTMLsteps = [
        {
            label: 'Basics of HTML',
            description: `Learn the basic building blocks of web pages, including headings, paragraphs, lists, and links.`,
            link: 'https://www.codecademy.com/learn/learn-html'
        },
        {
            label: 'CSS Fundamentals',
            description:
                `Understand how to select HTML elements and style them using CSS properties and values.`,
            link: 'https://www.codecademy.com/learn/learn-css'
        },
        {
            label: 'CSS Layout Techniques',
            description: `Explore Flexbox to align and distribute elements within a container with ease. Master CSS Grid to create complex layouts with rows and columns.`,
            link: 'https://flexboxfroggy.com/'
        },
        {
            label: 'Responsive Design',
            description: `Use media queries to adapt your website's layout to different screen sizes.`,
            link: 'https://www.freecodecamp.org/learn/responsive-web-design/'
        },
        {
            label: 'CSS Preprocessors',
            description: `Learn Sass to write more organized and maintainable CSS code.`,
            link: 'https://morioh.com/a/47dd64804173/sass-crash-course-learn-sass-in-20-minutes'
        }
    ];

    const JavascriptSteps = [
        {
            label: 'JavaScript Basics',
            description: `Dive into variables, data types, conditionals, loops, functions, and scope.`,
            link: 'https://www.freecodecamp.org/learn/javascript-algorithms-and-data-structures/basic-javascript/'
        },
        {
            label: 'DOM Manipulation',
            description: `Discover how to manipulate the Document Object Model (DOM) to change web page content dynamically through JavaScript.`,
            link: 'https://www.scaler.com/topics/javascript-dom-manipulation/'
        },
        {
            label: 'ES6+ Features',
            description: `Explore modern JavaScript features like arrow functions, template literals, destructuring, and spread/rest operators.`,
            link: 'https://www.geeksforgeeks.org/introduction-to-es6/'
        },
        {
            label: 'Asynchronous JavaScript',
            description: `Learn about asynchronous programming with promises, async/await, and handling asynchronous operations.`,
            link: 'https://www.freecodecamp.org/news/asynchronous-javascript/'
        }
    ];

    const ReactSteps = [
        {
            label: 'Component-Based Architecture',
            description: `Understand how to break down UI into components for reusability and manageability.`,
            link: 'https://react.dev/learn/describing-the-ui'
        },
        {
            label: 'State Management',
            description: `Learn about managing application state efficiently using react state hooks`,
            link: 'https://react.dev/learn/managing-state'
        },
        {
            label: 'Form Handling',
            description: `Capture user input, validate forms, and handle form submissions.`,
            link: 'https://reactjs.org/docs/forms.html'
        },
        {
            label: 'Routing',
            description: `Implement client-side routing for single-page applications`,
            link: 'https://reactrouter.com/en/6.15.0/start/tutorial'
        },
        {
            label: 'API Integration',
            description: `Learn to fetch data from APIs and integrate it into your applications.`,
            link: 'https://www.freecodecamp.org/news/how-to-consume-rest-apis-in-react/'
        }
    ];

    const APISteps = [
        {
            label: 'Fetching Data',
            description: `Explore different methods for fetching data from APIs, including using the Fetch API and libraries like Axios.`,
            link: 'https://axios-http.com/docs/intro'
        },
        {
            label: 'RESTful APIs',
            description: `Understand the principles of RESTful API design and how to work with RESTful endpoints.`,
            link: 'https://restfulapi.net/rest-api-design-tutorial-with-example/'
        }
    ]

    const GitSteps = [
        {
            label: 'Git Basics',
            description: `Understand the fundamentals of version control, including creating repositories, making commits, and working with branches.`,
            link: 'https://www.freecodecamp.org/news/introduction-to-git-and-github/'
        },
        {
            label: 'Collaboration',
            description: `Explore collaboration workflows using Git, including working with forks, pull requests, and resolving merge conflicts.`,
            link: 'https://medium.com/@jonathanmines/the-ultimate-github-collaboration-guide-df816e98fb67'
        }
    ];

    // Totol Steps = 18

    // The total Progress is for progress graph for every user whereas individual step progress is for saving the progress in DB
    const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);

    // Setup Progress
    const [setupCompletedSteps, setSetupCompletedSteps] = useState(0);

    const handleSetupStepComplete = () => {
        setSetupCompletedSteps(setupCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleSetupStepBack = () => {
        setSetupCompletedSteps(setupCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Javascript Progress
    const [jsCompletedSteps, setJsCompletedSteps] = useState(0);

    const handleJsStepComplete = () => {
        setJsCompletedSteps(jsCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleJsStepBack = () => {
        setJsCompletedSteps(jsCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //ReactJs Progress
    const [reactCompletedSteps, setReactCompletedSteps] = useState(0);

    const handleReactStepComplete = () => {
        setReactCompletedSteps(reactCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleReactStepBack = () => {
        setReactCompletedSteps(reactCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //API Integration Progress
    const [apiCompletedSteps, setApiCompletedSteps] = useState(0);

    const handleApiStepComplete = () => {
        setApiCompletedSteps(apiCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleApiStepBack = () => {
        setApiCompletedSteps(apiCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Version Control Progress
    const [gitCompletedSteps, setGitCompletedSteps] = useState(0);

    const handleGitStepComplete = () => {
        setGitCompletedSteps(gitCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGitStepBack = () => {
        setApiCompletedSteps(gitCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Firestore data

    useEffect(() => {
        saveProgressData({
            totalSteps: 18,
            totalCompletedSteps: totalCompletedSteps,
            setupCompletedSteps: setupCompletedSteps,
            jsCompletedSteps: jsCompletedSteps,
            reactCompletedSteps: reactCompletedSteps,
            apiCompletedSteps: apiCompletedSteps,
            gitCompletedSteps: gitCompletedSteps,
        });
    }, [totalCompletedSteps, setupCompletedSteps, jsCompletedSteps, reactCompletedSteps, apiCompletedSteps, gitCompletedSteps]);

    const {currentUser, isLoading} = useUserAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const asyncFunc = async() => {
            const progressData = await getProgressData();
            console.log(progressData);
            if (progressData) {
                setTotalCompletedSteps(progressData.totalCompletedSteps);
                setSetupCompletedSteps(progressData.setupCompletedSteps);
                setJsCompletedSteps(progressData.jsCompletedSteps);
                setReactCompletedSteps(progressData.reactCompletedSteps);
                setApiCompletedSteps(progressData.apiCompletedSteps);
                setGitCompletedSteps(progressData.gitCompletedSteps);
            }
            console.log(setupCompletedSteps)
        };
        asyncFunc();
        if(!currentUser && !isLoading){
            setError('Error');
        }
        else{
            setError('');
        }
    }, [currentUser]);


    return (
        <body>
            <HomeNavbar />
            <h1 className='tech-main-title'>Frontend Web Development</h1>
            <div className='web-container'>
                <div className='html-container'>
                    <h1 className='tech-title'>Setup and Basics</h1>
                    <VerticalStepper steps={HTMLsteps} onStepComplete={handleSetupStepComplete} onStepBack={handleSetupStepBack} stepsCompleted={setupCompletedSteps}/>
                </div>
                <div className='js-container'>
                    <h1 className='tech-title'>Javascript</h1>
                    <VerticalStepper steps={JavascriptSteps} onStepComplete={handleJsStepComplete} onStepBack={handleJsStepBack} stepsCompleted={jsCompletedSteps}/>
                </div>
                <div className='react-container'>
                    <h1 className='tech-title'>ReactJs</h1>
                    <VerticalStepper steps={ReactSteps} onStepComplete={handleReactStepComplete} onStepBack={handleReactStepBack} stepsCompleted={reactCompletedSteps}/>
                </div>
                <div className='api-container'>
                    <h1 className='tech-title'>API Integration</h1>
                    <VerticalStepper steps={APISteps} onStepComplete={handleApiStepComplete} onStepBack={handleApiStepBack} stepsCompleted={apiCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Version Control (Git)</h1>
                    <VerticalStepper steps={GitSteps} onStepComplete={handleGitStepComplete} onStepBack={handleGitStepBack} stepsCompleted={gitCompletedSteps}/>
                </div>
            </div>
            <ErrorModal errorMsg='Plz Login To Save Your Progress!' isError={error} />
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </body>
    );
}

export default Frontend;